import React from 'react';
import './theme.css';

const Theme = (props) => {
    return ( 
        <>
        <div className="theme">
            <h2>{props.theme}</h2>
            <p>{props.themeDesc}</p>
        </div>
        </>
     );
}
 
export default Theme;